"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(theme, props) {
  var palette = theme.palette;
  var paddingTop = theme.paddingTop;

  if (!props.closeAvailable) {
    paddingTop = palette.gutter * 4 + 'px';
  }

  return {
    root: {
      width: theme.width,
      paddingTop: paddingTop,
      paddingBottom: theme.paddingBottom,
      paddingLeft: theme.paddingLeft,
      paddingRight: theme.paddingRight
    },
    title: {
      textAlign: 'center',
      fontSize: palette.tsXXLarge,
      lineHeight: palette.tlXXLarge,
      color: palette.tFilled,
      marginBottom: palette.gutter * 3 + 'px'
    },
    content: {
      marginTop: theme.marginTop,
      marginBottom: theme.marginBottom,
      marginLeft: theme.marginLeft,
      marginRight: theme.marginRight,
      textAlign: 'center'
    },
    controls: {
      textAlign: 'center'
    },
    button: {
      display: 'inline-block'
    }
  };
}